'use client';

import { Button } from '@common/components';

import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { WELLO_IMAGE_PREFIX_URL } from '@/constants';

import { useInviteEventPeriodValue } from '../invite/_hooks/useInviteEventPeriodValue';

export const RepeatDonorSection = () => {
  const isSecondEvent = useInviteEventPeriodValue(false, true, {
    ssrFallbackValue: false,
  });

  return (
    <section
      id="repeat-donor"
      className={
        isSecondEvent
          ? 'flex w-full scroll-mt-46 flex-col items-center gap-32 overflow-hidden bg-Gray-black px-32 py-60'
          : 'hidden'
      }
    >
      <div className="flex w-full max-w-[375px] flex-col items-center gap-20">
        <div className="rounded-xxlarge bg-[#f6e0cf] px-20 py-6">
          <p className="text-center font-700 text-Gray-black typo-body1">
            Event 4
          </p>
        </div>

        <div className="flex flex-col items-center gap-8 text-center">
          <p className="font-700 text-[#f6e0cf] typo-h7">
            여러 지역에 기부하면? BIG 경품 혜택
          </p>
          <h2 className="font-800 text-[#f6e0cf] typo-h4">
            돌아온! 웰로 로컬 투어!
          </h2>
          <p className="font-500 text-Gray-white/70 typo-h7">
            12월, 웰로에서 2회 이상 기부 시<br />
            최대 100만 원 경품 자동 추첨!
          </p>
        </div>
      </div>

      <div className="flex w-full max-w-[375px] flex-col items-center gap-24">
        <div className="relative aspect-[203/329] size-full max-w-200">
          <Image
            src={`${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/regional-stamps.png`}
            alt="지역별 스탬프"
            fill
            sizes="375px"
          />
        </div>

        <Button className="w-full bg-R-600" asChild>
          <CustomLink href="/donation/event/stamp-2">
            이벤트 자세히 보기
          </CustomLink>
        </Button>
      </div>
    </section>
  );
};
